import React from 'react'

import './InfoCard.css'

export class InfoCard extends React.Component{
    constructor(props){
        super(props)
        console.log(this.props.imageURL);
        
    }

    render(){
        return(
            <div className="infocard_container">
                <div className="infocard_infoblock">
                    <div className="infocard_icon" >{this.props.icon}</div>
                    <h1 className="infocard_titulo"  id={this.props.id}>{this.props.title}</h1>
                    <p className="infocard_parrafo">{this.props.parragraph}</p>
                </div>
                
            </div>
        )
    }
}